interface SectionHeadingProps {
  eyebrow: string;
  title: string;
  desc?: string;
}

export default function SectionHeading({ eyebrow, title, desc }: SectionHeadingProps) {
  return (
    <div className="max-w-2xl">
      <span className="inline-flex items-center gap-2 rounded-full bg-secondary-100 px-3 py-1 font-label text-xs font-semibold tracking-wide text-secondary-900">
        <i className="ri-play-circle-line text-secondary-700"></i>
        {eyebrow}
      </span>
      <h2 className="mt-3 font-heading text-2xl font-bold leading-snug text-foreground-950 md:text-3xl">
        {title}
      </h2>
      {desc ? (
        <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">{desc}</p>
      ) : null}
    </div>
  );
}